export default __webpack_public_path__ + "static/media/lanzamiento_pasado.73a85fb0.jpg";